import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthentication } from 'queries/session';
import { INullable } from 'utils/types';

import { PermissionDeniedIcon } from './styled';
import WrongPageLayout from './WrongPageLayout';

interface IAccessForbidden {
  onReset?: () => void;
  subtitle?: INullable<string>;
}

const AccessForbidden: React.FC<IAccessForbidden> = ({ onReset, subtitle }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'accessForbidden' });
  const { logout } = useAuthentication();

  const onBack = async () => {
    await logout();
    onReset?.();
  };

  return (
    <WrongPageLayout
      buttonText={t('backButton')}
      icon={<PermissionDeniedIcon />}
      onClick={onBack}
      subtitle={subtitle || t('subtitle')}
      title={t('title')}
    />
  );
};

export default AccessForbidden;
